/**
 * Text written by models, agents and people is Markdown. Where it has to sit on one line (a
 * truncated summary, a tooltip, a phone's notification card), its marks are taken out rather than
 * shown as `**` and `[…](…)`. The console renders the full text with components/Markdown.tsx.
 *
 * No lookbehind: the mobile app's JavaScript engine may not have it.
 */
export function plainText(text) {
    if (!text)
        return "";
    return text
        .replace(/```[\s\S]*?```/g, " ")
        .replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1")
        .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
        .replace(/^\s{0,3}(#{1,6}\s+|>\s?|[-*+]\s+(\[[ xX]\]\s+)?|\d+[.)]\s+)/gm, "")
        .replace(/(\*\*|__)(.+?)\1/g, "$2")
        .replace(/(^|[^\w*])([*_])([^*_\s](?:[^*_]*[^*_\s])?)\2(?=[^\w*]|$)/g, "$1$3")
        .replace(/~~(.+?)~~/g, "$1")
        .replace(/`([^`]+)`/g, "$1")
        .replace(/\s+/g, " ")
        .trim();
}
//# sourceMappingURL=text.js.map